import type { FC } from "react";

import {
  ValidationWrapper,
  type ValidationWrapperProps,
} from "../../../common-ui/form-fields/ValidationWrapper";
import type {
  UpdateIntermodalBookingFormModel,
  UpdateIntermodalBookingGoodFormModel,
} from "../../../services/intermodal/updateIntermodalReducer";
import { useUpdateIntermodalField } from "../hooks/useUpdateIntermodalField";
import { useUpdateIntermodalGoodsField } from "../hooks/useUpdateIntermodalGoodsFields";

interface UpdateIntermodalValidationWrapperProps extends Omit<
  ValidationWrapperProps,
  "validationError"
> {
  name: keyof UpdateIntermodalBookingFormModel;
}

export const UpdateIntermodalValidationWrapper: FC<
  UpdateIntermodalValidationWrapperProps
> = ({ name, ...props }) => {
  const { validationError } = useUpdateIntermodalField(name);
  return <ValidationWrapper validationError={validationError} {...props} />;
};

interface UpdateIntermodalGoodsValidationWrapperProps extends Omit<
  ValidationWrapperProps,
  "validationError"
> {
  goodId: string;
  name: keyof UpdateIntermodalBookingGoodFormModel;
}

export const UpdateIntermodalGoodsValidationWrapper: FC<
  UpdateIntermodalGoodsValidationWrapperProps
> = ({ name, goodId, ...props }) => {
  const { validationError } = useUpdateIntermodalGoodsField(goodId, name);
  return <ValidationWrapper validationError={validationError} {...props} />;
};
